import { graphql } from '@/gql'

export const GetJobCandidatesQuery = graphql(/* GraphQL */ `
  query jobCandidates($jobIds: [ID!], $first: Int) {
    jobCandidates(jobs: $jobIds, first: $first) {
      data {
        ...JobCandidate
      }
    }
  }
`)

export const OnboardWorkerModalQuery = graphql(/* GraphQL */ `
  query onboardWorkerModal($id: ID!) {
    jobCandidate(id: $id) {
      id
      workerIsTrustedContact
      onboardingRequestsHireDetails
    }
  }
`)
